// SignageAddDynamicCost.tsx
import React, { useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { showError, showSuccess } from "toast/toast";
import { nameValidation, statusValidation } from "validationSchemas/common";
import { UIInput, UIReactSelect, UIReactMultiSelect } from "components/Inputfields";
import DynamicCostHelpModal from "components/SignagedynamicCostToolTip";
/* --------------------------- Styled reusable children --------------------------- */

// type BaseFieldProps = {
//   formik: ReturnType<typeof useFormik<any>>;
//   name: string;
//   label: string;
//   required?: boolean;
//   placeholder?: string;
// };
// export function UIInput({ formik, name, label, required, placeholder }: BaseFieldProps) {
//   const [hover, setHover] = useState(false);
//   const [focus, setFocus] = useState(false);

//   const touched = (formik.touched as any)?.[name];
//   const error = (formik.errors as any)?.[name];
//   const hasError = !!(touched && error);

//   // Dynamic colors for normal / hover+focus / error
//   const bgColor = hover || focus ? "#fafafa" : "#f5f6fa";      // <— your hover bg
//   const borderColor = hasError
//     ? "#747981"
//     : hover || focus
//     ? "#9ca3af"                                                // <— your hover border
//     : "#c9ced6";

//   const style: React.CSSProperties = {
//     width: "100%",
//     height: 45,                                                // <— increased height
//     borderRadius: 10,
//     padding: "10px 12px",                                      // a bit more vertical padding
//     borderWidth: 2,
//     borderStyle: "solid",
//     borderColor,
//     backgroundColor: bgColor,
//     outline: "none",
//     transition: "all .2s ease-in-out",                        // <— your transition
//     boxShadow: "none",
//     color: "#111827",
//   };

//   return (
//     <div className="mb-3">
//       <label className="form-label">
//         {label} {required && <span className="text-danger">*</span>}
//       </label>

//       <input
//         id={name}
//         name={name}
//         className={`form-control ${hasError ? "is-invalid" : ""}`}
//         style={style}
//         value={(formik.values as any)[name] ?? ""}
//         onChange={formik.handleChange}
//         onFocus={() => setFocus(true)}
//         onBlur={(e) => {
//           setFocus(false);
//           formik.handleBlur(e);
//         }}
//         onMouseEnter={() => setHover(true)}
//         onMouseLeave={() => setHover(false)}
//         placeholder={placeholder}
//         type="text"
//         aria-invalid={hasError}
//       />

//       {hasError ? <div className="invalid-feedback d-block">{error}</div> : null}
//     </div>
//   );
// }



// /** Native select matching the same visual style as inputs */
// function UISelect({
//   formik,
//   name,
//   label,
//   required,
//   placeholder,
//   options,
// }: BaseFieldProps & { options: Array<{ value: string; label: string }> }) {
//   const [hover, setHover] = useState(false);
//   const [focus, setFocus] = useState(false);
//   const touched = (formik.touched as any)?.[name];
//   const error = (formik.errors as any)?.[name];

//   const style: React.CSSProperties = {
//     width: "100%",
//     height: 40,
//     borderRadius: 10,
//     padding: "8px 12px",
//     border: "1px solid",
//     borderColor: focus ? "#7c8ac9" : hover ? "#b0b7c7" : "#c9ced6",
//     background: "#f5f6fa",
//     outline: "none",
//     transition: "border-color .15s ease, box-shadow .15s ease",
//     boxShadow: focus ? "0 0 0 2px rgba(86,107,255,.15)" : "none",
//     color: "#111827",
//     appearance: "none",
//     backgroundImage:
//       "linear-gradient(45deg, transparent 50%, #6b7280 50%),linear-gradient(135deg, #6b7280 50%, transparent 50%),linear-gradient(to right, #f5f6fa, #f5f6fa)",
//     backgroundPosition: "calc(100% - 18px) calc(1em + 2px), calc(100% - 13px) calc(1em + 2px), 0 0",
//     backgroundSize: "5px 5px, 5px 5px, 100% 100%",
//     backgroundRepeat: "no-repeat",
//   };

//   return (
//     <div className="mb-3">
//       <label className="form-label ">
//         {label} {required && <span className="text-danger">*</span>}
//       </label>
//       <select
//         id={name}
//         name={name}
//         value={(formik.values as any)[name] ?? ""}
//         className={`form-control ${touched && error ? "is-invalid" : ""}`}
//         style={style}
//         onChange={formik.handleChange}
//         onBlur={(e) => {
//           setFocus(false);
//           formik.handleBlur(e);
//         }}
//         onFocus={() => setFocus(true)}
//         onMouseEnter={() => setHover(true)}
//         onMouseLeave={() => setHover(false)}
//       >
//         <option value="">{placeholder || "- Select -"}</option>
//         {options.map((o) => (
//           <option key={o.value} value={o.value}>
//             {o.label}
//           </option>
//         ))}
//       </select>
//       {touched && error ? <div className="invalid-feedback d-block">{error}</div> : null}
//     </div>
//   );
// }

// /** React-select styled to visually match inputs from screenshot */
// function UIReactSelect({
//   formik,
//   name,
//   label,
//   required,
//   placeholder,
//   options,
// }: BaseFieldProps & { options: Array<{ value: string; label: string }> }) {
//   const touched = (formik.touched as any)?.[name];
//   const error = (formik.errors as any)?.[name];
//   const hasError = !!(touched && error);

//   return (
//     <div className="mb-3">
//       <label className="form-label">
//         {label} {required && <span className="text-danger">*</span>}
//       </label>

//       <Select
//         inputId={name}
//         name={name}
//         options={options}
//         value={options.find((o) => o.value === (formik.values as any)[name]) || null}
//         onChange={(opt) => formik.setFieldValue(name, (opt as any)?.value || "")}
//         onBlur={() => formik.setFieldTouched(name, true)}
//         placeholder={placeholder || "Select..."}
//         classNamePrefix="rs"
//         styles={{
//           control: (base, state) => {
//             const focused = state.isFocused;
//             return {
//               ...base,
//               minHeight: 45,
//               height: 45,
//               borderRadius: 10,
//               backgroundColor: focused ? "#fafafa" : "#f5f6fa",
//               borderWidth: 2,
//               borderStyle: "solid",
//               borderColor: hasError
//                 ? "#747981"               // error
//                 : focused
//                 ? "#9ca3af"               // focus border
//                 : "#c9ced6",              // normal
//               boxShadow: "none",
//               outline: "none",
//               transition: "all .2s ease-in-out", // smooth hover/focus
//               ":hover": {
//                 borderColor: hasError ? "#747981" : "#9ca3af",
//                 backgroundColor: "#fafafa",
//               },
//             };
//           },
//           valueContainer: (b) => ({
//             ...b,
//             padding: "6px 12px",
//             height: 48,
//           }),
//           indicatorsContainer: (b) => ({
//             ...b,
//             paddingRight: 10,
//             height: 48,
//           }),
//           placeholder: (b) => ({ ...b, color: "#6b7280" }),
//           singleValue: (b) => ({ ...b, color: "#111827" }),
//           menu: (b) => ({ ...b, borderRadius: 10, overflow: "hidden" }),
//         }}
//         theme={(t) => ({
//           ...t,
//           colors: {
//             ...t.colors,
//             primary: "#9ca3af",       // match hover/focus border tone
//             primary25: "rgba(156,163,175,0.15)",
//             primary50: "rgba(156,163,175,0.25)",
//           },
//         })}
//       />

//       {hasError ? <div className="invalid-feedback d-block">{error}</div> : null}
//     </div>
//   );
// }


// function UICheckbox({
//   formik,
//   name,
//   label,
// }: {
//   formik: ReturnType<typeof useFormik<any>>;
//   name: string;
//   label: string;
// }) {
//   return (
//     <label className="form-check d-flex align-items-center gap-2 me-4">
//       {/* CHECKBOX (not radio) */}
//       <input
//         type="checkbox"
//         className="form-check-input"
//         name={name}
//         id={name}
//         checked={!!(formik.values as any)[name]}
//         onChange={formik.handleChange}
//         style={{ width: 16, height: 16, cursor: "pointer" }}
//       />
//       <span className="form-check-label" style={{ cursor: "pointer" }}>
//         {label}
//       </span>
//     </label>
//   );
// }
import TaxRuleSelect from "components/services/taxrulesandTaxgroupsui";
import { getAuthCookie } from "../../utils/authCookies";

type Warehouse = {
  _id: string;
  label: string;
  address?: {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    latitude?: number;
    longitude?: number;
  };
};

type FormVals = {
  name: string;
  warehouse_id: string;
  base_cost: string | number;
  distance_covered: string | number;
  additional_cost_per_mile: string | number;
  statuss: "Active" | "Inactive" | "";
  installation: boolean;
  removal: boolean;
  default_cost: boolean;
  taxable: boolean;
  checkboxGroup: string;
  tax_rule_id: string;
  tax_group: any | null;
  tax_rule: any | null;
};

const ZERO_OBJECT_ID = "000000000000000000000000";

const oid = (v: any) => (v && typeof v === "object" && "$oid" in v ? v.$oid : v);

/** Ignore empty / Go zero ObjectID values from API responses. */
function normalizeTaxObjectId(v: any): string | null {
  const raw = oid(v);
  if (raw == null) return null;
  const id = String(raw).trim();
  if (!id || id === "0" || id === ZERO_OBJECT_ID) return null;
  return id;
}

/** Encode saved tax group/rule from GET /dynamic-costs/:id for the TaxRuleSelect. */
function hydrateTaxSelection(dynamicCost: any): {
  tax_rule_id: string;
  tax_group: any | null;
  tax_rule: any | null;
} {
  if (!dynamicCost?.is_taxable) {
    return { tax_rule_id: "", tax_group: null, tax_rule: null };
  }

  // Prefer plain tax_group_id / tax_rule_id from response; skip zero ObjectIDs.
  const groupId =
    normalizeTaxObjectId(dynamicCost?.tax_group_id) ||
    normalizeTaxObjectId(dynamicCost?.tax_group?._id) ||
    normalizeTaxObjectId(dynamicCost?.tax_group?.id);
  const ruleId =
    normalizeTaxObjectId(dynamicCost?.tax_rule_id) ||
    normalizeTaxObjectId(dynamicCost?.tax_rule?._id) ||
    normalizeTaxObjectId(dynamicCost?.tax_rule?.id);

  if (groupId) {
    return {
      tax_rule_id: `group-${groupId}`,
      tax_group: dynamicCost?.tax_group || { _id: groupId },
      tax_rule: null,
    };
  }
  if (ruleId) {
    return {
      tax_rule_id: `rule-${ruleId}`,
      tax_group: null,
      tax_rule: dynamicCost?.tax_rule || { _id: ruleId },
    };
  }
  return { tax_rule_id: "", tax_group: null, tax_rule: null };
}

export default function SignageDynamicCostForm() {
  const { costId } = useParams<{ costId: string }>();
  const isEdit = Boolean(costId);
  // const isEdit = !!costId;
  const navigate = useNavigate();
  const token = getAuthCookie("sessionToken");
  const location = useLocation();
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';

  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [dynamicCost, setDynamicCost] = useState<any>(null);
  const [openHelp, setOpenHelp] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/warehouses`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        setWarehouses(Array.isArray(data) ? data : []);
      } catch { }
    })();
  }, [token]);

  useEffect(() => {
    if (!isEdit) return;
    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/dynamic-costs/${costId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        setDynamicCost(data);
      } catch { }
    })();
  }, [isEdit, costId, token]);

  const warehousesOptions = useMemo(
    () => warehouses.map((w) => ({ value: w._id, label: w.label })),
    [warehouses]
  );

  const schema = Yup.object({
    name: nameValidation,
    warehouse_id: Yup.string().required("Warehouse is required"),
    base_cost: Yup.number()
      .transform((v, o) => (o === "" ? undefined : v))
      .typeError("Base cost must be a number")
      .required("Base cost is required")
      .min(0),
    distance_covered: Yup.number()
      .transform((v, o) => (o === "" ? undefined : v))
      .typeError("Distance covered must be a number")
      .required("Distance covered is required")
      .min(0),
    additional_cost_per_mile: Yup.number()
      .transform((v, o) => (o === "" ? undefined : v))
      .typeError("Additional cost per mile must be a number")
      .required("Additional cost per mile is required")
      .min(0),
    // statuss: statusValidation as any,
    installation: Yup.boolean(),
    removal: Yup.boolean(),
    default_cost: Yup.boolean(),
    taxable: Yup.boolean(),
    checkboxGroup: Yup.string().test(
      "checkbox-required",
      "At least one of Installation or Removal must be selected",
      function (_val, ctx) {
        const { installation, removal } = ctx.parent as FormVals;
        // At least one must be true
        return installation || removal;
      }
    ),
  });

  const formik = useFormik<FormVals>({
    enableReinitialize: true,
    initialValues: {
      name: dynamicCost?.name || "",
      warehouse_id: dynamicCost?.warehouse?._id || "",
      base_cost: dynamicCost?.base_cost ?? "",
      distance_covered: dynamicCost?.distance_covered ?? "",
      ...hydrateTaxSelection(dynamicCost),
      additional_cost_per_mile: dynamicCost?.additional_cost_per_mile ?? "",
      statuss: (dynamicCost?.status as any) || "Active",
      installation: Array.isArray(dynamicCost?.cost_type)
        ? dynamicCost.cost_type.includes("installation")
        : dynamicCost?.cost_type === "installation",
      removal: Array.isArray(dynamicCost?.cost_type)
        ? dynamicCost.cost_type.includes("removal")
        : dynamicCost?.cost_type === "removal",
      default_cost: !!dynamicCost?.is_default,
      taxable: !!dynamicCost?.is_taxable,
      checkboxGroup: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setFormSubmitting(true);
      try {
        const selectedWarehouse = warehouses.find(
          (w) => w._id === values.warehouse_id
        );

        // Determine cost_type based on which checkboxes are selected
        // Always send as array
        let cost_type: string[] = [];
        if (values.installation) {
          cost_type.push("installation");
        }
        if (values.removal) {
          cost_type.push("removal");
        }

        const groupId = values.taxable
          ? normalizeTaxObjectId(values.tax_group?._id ?? values.tax_group?.id)
          : null;

        const ruleId =
          values.taxable && !groupId
            ? normalizeTaxObjectId(values.tax_rule?._id ?? values.tax_rule?.id)
            : null;

        const payload = {
          name: values.name,
          cost_type: cost_type,
          base_cost: Number(values.base_cost),
          distance_covered: Number(values.distance_covered),
          additional_cost_per_mile: Number(values.additional_cost_per_mile),
          warehouse: selectedWarehouse,
          status: values.statuss,
          is_default: values.default_cost === true,
          // is_taxable: values.taxable === true,
          is_taxable: !!values.taxable,
          ...(groupId ? { tax_group_id: groupId } : {}),
          ...(ruleId ? { tax_rule_id: ruleId } : {}),
        };

        const url = isEdit
          ? `${process.env.REACT_APP_API_URL}/dynamic-costs/${costId}`
          : `${process.env.REACT_APP_API_URL}/dynamic-costs`;
        const method = isEdit ? "PUT" : "POST";

        const res = await fetch(url, {
          method,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err?.message || "Save failed");
        }

        showSuccess(isEdit ? "Dynamic cost updated successfully!" : "Dynamic cost added successfully!");
        navigate(`${baseRoute}/dynamic-costs`);
      } catch (e: any) {
        showError(e?.message || "Failed to save");
      } finally {
        setFormSubmitting(false);
      }
    },
  });

  /* --------------------------------- UI --------------------------------- */
  return (
    <>
      <div className="content container ">

        <div className="row">
          <div className="col-md-12 d-flex justify-content-center">
            <div className="col-md-9">
              <div className="mb-5">

                {/* <div className="mb-2" style={{ color: "#6b7280", fontSize: 14 }}>
                <Link to={`${baseRoute}/dynamic-costs`} className="text-decoration-none" style={{ color: "#6b7280" }}>
                  Dynamic Costs
                </Link>{" "}
                &gt; <span style={{ color: "#111827" }}>{isEdit ? "Edit Dynamic Cost" : "Add Dynamic Cost"}</span>
              </div> */}
                {/* <div className="mt-1 mb-3">
                <h3 className=" fs-22 m-0 roboto-new" style={{ color: "#111827" }}>{isEdit ? "Edit Dynamic Cost" : "Add Dynamic Cost"}</h3>
              </div> */}
                <div className="d-flex align-items-center gap-2">
                  <h3 className="fs-22 m-0 roboto-new" style={{ color: "#111827" }}>
                    {isEdit ? "Edit Dynamic Cost" : "Add Dynamic Cost"}
                  </h3>

                  {/* Help Icon */}
                  <button
                    onClick={() => setOpenHelp(true)}
                    className="d-inline-flex align-items-center justify-content-center p-0 border-0 bg-transparent"
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      className="d-inline-flex align-items-center justify-content-center"
                      style={{
                        width: 26,
                        height: 26,
                        borderRadius: "50%",
                        background: "#eef4ff",
                      }}
                    >
                      <i
                        className="bi bi-question-circle-fill"
                        style={{ fontSize: 18, color: "#155dfc" }}
                      ></i>
                    </span>
                  </button>

                  <DynamicCostHelpModal
                    open={openHelp}
                    onClose={() => setOpenHelp(false)}
                  />
                </div>


              </div>
              <div
                className="box-shadow shadow-border-3 mb-5"
              >
                {/* Card header */}
                <div
                  className="d-flex align-items-center gap-2 mx-4"
                  style={{ padding: "33px 18px", borderBottom: "1px solid #eef2f7" }}
                >
                  <span
                    className="d-inline-flex align-items-center justify-content-center"
                    style={{ width: 26, height: 26 }}
                  >
                    <i
                      className="bi bi-currency-dollar"
                      style={{ fontSize: 26, color: "#155dfc", lineHeight: 1 }}
                    />
                  </span>

                  <div className="fs-19 roboto-new">Dynamic Cost Details</div>
                </div>


                {/* Body */}
                <form onSubmit={formik.handleSubmit}>
                  <div style={{ padding: "54px 18px  0px 18px" }} className="mx-4">
                    <div className=" mb-2 ms-2 fs-19 roboto-new">Cost Information</div>
                    <hr />
                    <div className="row ms-1" id="row-overlap">
                      <div className="col-lg-4 mb-2 roboto-new" id="row-overlap">
                        <UIInput
                          formik={formik}
                          name="name"
                          label="Name of the cost"
                          required
                          placeholder="Enter cost name"
                        />
                      </div>

                      <div className="col-lg-4 roboto-new" id="row-overlap">
                        <UIInput
                          formik={formik}
                          name="base_cost"
                          label="Base cost"
                          required
                          placeholder="Enter base cost"
                        />
                      </div>

                      <div className="col-lg-4 roboto-new" id="row-overlap">
                        <UIInput
                          formik={formik}
                          name="distance_covered"
                          label="Distance covered"
                          required
                          placeholder="Enter distance"
                        />
                      </div>

                      <div className="col-lg-4 mb-2 roboto-new" id="row-overlap">
                        <UIInput
                          formik={formik}
                          name="additional_cost_per_mile"
                          label="Additional cost per mile"
                          required
                          placeholder="Enter cost per mile"
                        />
                      </div>

                      <div className="col-lg-4 roboto-new" id="row-overlap">
                        <UIReactSelect
                          formik={formik}
                          name="warehouse_id"
                          label="Warehouse"
                          required
                          options={warehousesOptions}
                          placeholder="Select..."
                        />
                      </div>

                      <div className="col-lg-4 roboto-new" id="row-overlap">
                        <UIReactSelect
                          formik={formik}
                          name="statuss"
                          label="Status"
                          options={[
                            { value: "Active", label: "Active" },
                            { value: "Inactive", label: "Inactive" },
                          ]}
                          placeholder="- Select -"
                        />
                      </div>

                      {/* Checkboxes row */}
                      {/* Installation / Removal (exactly like image #2) */}
                      <div className="col-md-12 mt-1 ms-2 roboto-new" id="row-overlap">
                        <div className="row" id="row-overlap">
                          {/* Title on top-left */}
                          <div className="col-12 ms-1" id="row-overlap">
                            <label className=" d-block mb-3" style={{ fontSize: 13 }}>
                              Installation/Removal
                            </label>
                          </div>

                          {/* Checkboxes in one row with spacing */}
                          <div className="col-md-9 col-sm-6 mb-3 ms-1" id="row-overlap">
                            <div className="d-flex flex-wrap align-items-center justify-content-between" style={{ gap: 40 }}>
                              <div className="form-check d-flex align-items-center gap-2">
                                <input
                                  id="installation"
                                  name="installation"
                                  type="checkbox"
                                  className="form-check-input square-checkbox"
                                  checked={formik.values.installation}
                                  onChange={(e) => {
                                    formik.setFieldValue("installation", e.target.checked);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <label htmlFor="installation" className="form-check-label ">Installation</label>
                              </div>

                              <div className="form-check d-flex align-items-center gap-2">
                                <input
                                  id="removal"
                                  name="removal"
                                  type="checkbox"
                                  className="form-check-input square-checkbox"
                                  checked={formik.values.removal}
                                  onChange={(e) => {
                                    formik.setFieldValue("removal", e.target.checked);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <label htmlFor="removal" className="form-check-label ">Removal</label>
                              </div>

                              <div className="form-check d-flex align-items-center gap-2">
                                <input
                                  id="default_cost"
                                  name="default_cost"
                                  type="checkbox"
                                  className="form-check-input square-checkbox"
                                  checked={formik.values.default_cost}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <label htmlFor="default_cost" className="form-check-label ">Default Cost</label>
                              </div>

                              <div className="form-check d-flex align-items-center gap-2">
                                <input
                                  id="taxable"
                                  name="taxable"
                                  type="checkbox"
                                  className="form-check-input square-checkbox"
                                  checked={formik.values.taxable}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                                <label htmlFor="taxable" className="form-check-label ">Taxable</label>
                              </div>
                            </div>

                            {formik.errors?.checkboxGroup && (
                              <div className="text-danger mt-2">{formik.errors.checkboxGroup}</div>
                            )}
                          </div>

                          <div className="col-lg-4 roboto-new" id="row-overlap">

                            <TaxRuleSelect
                              token={token || ""}                // your API token
                              taxable={formik.values.taxable}    // controls visibility
                              formik={formik}                    // lets the component write into Formik
                              taxRuleIdName="tax_rule_id"
                              groupFieldName="tax_group"
                              ruleFieldName="tax_rule"
                              wrapperClassName="d-flex flex-column ms-1"
                              selectClassName="form-select"
                              label="Tax Rule / Tax Group"
                              mode={isEdit ? "edit" : "add"}
                            />

                          </div>

                          <div className="col-12 mb-3" id="row-overlap">
                            <hr />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* Footer */}
                  <div className="d-flex justify-content-between align-items-center mx-4" style={{ padding: "14px 18px" }}>
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="btn back-btn surface-btn fw-bold fs-16"
                    >
                      <i className="bi bi-chevron-left me-2" />
                      Back
                    </button>

                    <button
                      type="submit"
                      className="btn save-btn surface-btn fw-bold fs-16"
                      disabled={formSubmitting}
                    >
                      {formSubmitting ? "Submitting..." : "Save"}
                    </button>
                  </div>

                </form>
              </div>
              {/* /Card */}
            </div>
          </div>
        </div>
      </div>


    </>
  );
}
